module.exports = __webpack_public_path__ + "img/iconfont.5dbeabcd.svg";